(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    var autoplay = $('.cstm-video').find('.video-poster').attr('autoplay');
    var autoplay_mob = $('.cstm-video').find('.video-preview').attr('autoplay');
    var poster_mob = $('.cstm-video').find('.video-preview').attr('poster');
     // console.log('poster_mob', poster_mob);

      if(autoplay){
        $('.cstm-video').find('.video-poster').attr('poster','');
      }
       if(autoplay_mob){
        $('.cstm-video').find('.video-preview').attr('poster','');
      }
      $('body').on('click touchstart', function() {
        if ($('#ban_vdo').length > 0) {
          const videoElement = document.getElementById('ban_vdo');
          if (videoElement.paused) {
            videoElement.play();
          }
        }
      });

      const videoElements = document.getElementById('ban_vdo');
      if (videoElements) {
        videoElements.play().then(() => {}).catch((error) => {
          const poster_showMob = document.getElementsByClassName('mobile_show_img');
          videoElements.setAttribute("hidden","hidden");
          var mobile_imgg = $('.mobile_show_img').removeAttr('hidden');
        });
      }
  });

  } catch(e) { console.error(e); }
})();

})();
